import { css, cx, Styles } from '../../../../styled-system/css';
import {
  loadingSpinner,
  type LoadingSpinnerVariantProps,
} from '../../../../styled-system/recipes';

export interface LoadingSpinnerProps extends LoadingSpinnerVariantProps {
  css?: Styles;
}

export const LoadingSpinner = ({ css: cssProp, size }: LoadingSpinnerProps) => {
  return <span className={cx(loadingSpinner({ size }), css(cssProp))} />;
};
